import { privateAxios } from '@/common/api/axios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type UseConsumptionsProps<T> = {
  filters?: {
    page?: number
    status?: string
    clientBranchId?: string
    establishmentCompanyId?: string
    establishmentBranchId?: string
  }
  mapper?: (data: any) => T
}

export const useConsumptions = <T,>({
  filters: { page, status, clientBranchId, establishmentCompanyId, establishmentBranchId } = {},
  mapper = Mapper.default<T>(),
}: UseConsumptionsProps<T>) => {
  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['clientConsumptions', page, status, clientBranchId, establishmentCompanyId, establishmentBranchId],
    queryFn: () => {
      return privateAxios.get('/consumptions', {
        params: {
          page,
          'q[status_eq]': status,
          'q[client_branch_id_eq]': clientBranchId,
          'q[establishment_company_id_eq]': establishmentCompanyId,
          'q[establishment_branch_id_eq]': establishmentBranchId,
        },
      })
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => ({
      data: mapper(data?.data?.data),
      meta: data?.data?.meta,
    }),
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}
